import { StrictMode } from 'react'
import React from 'react'
import ReactDOM from 'react-dom'
import { createRoot } from 'react-dom/client'
import { HelmetProvider } from 'react-helmet-async'
import './index.css'
import './styles/mw.css'
import { migrateLegacyKeys } from './lib/migrateLegacyKeys'
import { installChunkReloadGuard } from './lib/chunkReload'
import './i18n' // Configura i18next antes de renderizar la app.
import { App } from './App'
import { resolveTenantSlug } from './lib/tenant'

// Antes de montar nada: si el navegador tiene el index viejo tras un
// despliegue, esto lo recarga en vez de dejar la pagina en blanco.
installChunkReloadGuard()

// Auditoría a11y con `@axe-core/react` solo en desarrollo. Reporta a la
// consola las violaciones que detecta tras cada render. No entra en el
// bundle de producción (la guardia de `import.meta.env.DEV` queda dead
// code y Rollup la purga).
if (import.meta.env.DEV) {
  void import('@axe-core/react').then(({ default: axe }) => {
    // 1000 ms de debounce para no flooding la consola en cada render.
    void axe(React, ReactDOM, 1000)
  })
}

// Favicon tenant-aware. Cuando el subdomain es mentor-wallet, sustituimos
// el favicon PV por uno propio MW (cuadrado navy con M blanca).
// Se hace en runtime antes del mount para evitar el flash del icono PV.
migrateLegacyKeys()
const tenantSlug = resolveTenantSlug()
if (tenantSlug === 'mentor-wallet') {
  const head = document.head
  // Eliminamos los <link rel="icon"|apple-touch-icon"> existentes para que
  // el navegador no caché el favicon PV anterior.
  head
    .querySelectorAll('link[rel="icon"], link[rel="apple-touch-icon"]')
    .forEach((node) => node.remove())
  const svg = document.createElement('link')
  svg.rel = 'icon'
  svg.type = 'image/svg+xml'
  svg.href = '/branding/mw/favicon.svg'
  head.appendChild(svg)
  // Title se actualiza desde PageMeta en cada ruta, pero seteamos un
  // título inicial coherente mientras carga la app.
  document.title = 'MentorWallet'
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </StrictMode>,
)
